import type { AssetTypesQuery } from '@/app/api/generated';
import type { HelpAsset, SortListItems, Spot, AssetTypeItem } from '@/types';

export const sortSpotByIndex = (
  spotList: Spot[] | HelpAsset[] | AssetTypesQuery['assetTypes']
): Spot[] | HelpAsset[] | AssetTypesQuery['assetTypes'] => {
  spotList.sort(
    (
      a: Spot | HelpAsset | AssetTypeItem,
      b: Spot | HelpAsset | AssetTypeItem
    ) => {
      if (a.attributes == null || b.attributes == null) return 0;
      // if (a.attributes.index == null || b.attributes.index == null) return -1;
      const lastIndex = 9999;
      const indexA =
        typeof a.attributes.index === 'string'
          ? parseInt(a.attributes.index)
          : a.attributes.index ?? lastIndex;
      const indexB =
        typeof b.attributes.index === 'string'
          ? parseInt(b.attributes.index)
          : b.attributes.index ?? lastIndex;
      if (indexA < indexB) return -1;
      if (indexA > indexB) return 1;

      return 0;
    }
  );

  return spotList;
};

export const sortByIndex = (spotList: SortListItems[]): SortListItems[] => {
  spotList.sort((a: SortListItems, b: SortListItems) => {
    if (a.item.index === undefined) return -1;
    if (b.item.index === undefined) return -1;
    if (a.item.index === -1) return -1;
    if (b.item.index === -1) return -1;

    const indexA =
      typeof a.item.index === 'string' ? parseInt(a.item.index) : a.item.index;
    const indexB =
      typeof b.item.index === 'string' ? parseInt(b.item.index) : b.item.index;
    if (indexA < indexB) return -1;
    if (indexA > indexB) return 1;

    return 0;
  });

  return spotList;
};

export const sortByDistanceInAsc = (
  spotList: SortListItems[]
): SortListItems[] => {
  spotList.sort((a: SortListItems, b: SortListItems) => {
    if (a.item.geoPoint === undefined) return -1;
    if (b.item.geoPoint === undefined) return -1;
    if (a.item.geoPoint.distance < b.item.geoPoint.distance) return -1;
    if (a.item.geoPoint.distance > b.item.geoPoint.distance) return 1;

    return 0;
  });

  return spotList;
};

export const sortBySyllabaryOrder = (
  spotList: SortListItems[]
): SortListItems[] => {
  spotList.sort((a: SortListItems, b: SortListItems) => {
    if (a.item.kana === undefined) return -1;
    if (b.item.kana === undefined) return -1;
    if (a.item.kana === '') return -1;
    if (b.item.kana === '') return -1;
    if (a.item.kana > b.item.kana) return -1;
    if (a.item.kana < b.item.kana) return 1;

    return 0;
  });

  return spotList.reverse();
};

// NOTE: 降順（新しい順）に並び替え
export const sortByUpdateAt = (spotList: SortListItems[]): SortListItems[] => {
  spotList.sort((a: SortListItems, b: SortListItems) => {
    if (a.item.updatedAt === undefined) return 1;
    if (b.item.updatedAt === undefined) return -1;
    if (a.item.updatedAt < b.item.updatedAt) return 1;
    if (a.item.updatedAt > b.item.updatedAt) return -1;

    return 0;
  });

  return spotList;
};

export const getSortedList = (
  sortType: string | null,
  spotList: SortListItems[],
  options?: {
    favoriteSpotIds?: Set<string>;
  }
) => {
  if (sortType === 'index') {
    spotList = sortByIndex(spotList);
  } else if (sortType === 'close') {
    spotList = sortByDistanceInAsc(spotList as SortListItems[]);
  } else if (sortType === 'syllabaryOrder') {
    spotList = sortBySyllabaryOrder(spotList as SortListItems[]);
  } else if (sortType === 'updateAt') {
    spotList = sortByUpdateAt(spotList as SortListItems[]);
  } else if (sortType === 'favorite') {
    const favoriteSpotIds = options?.favoriteSpotIds ?? new Set<string>();
    spotList.sort((a: SortListItems, b: SortListItems) => {
      const aIsFavoriteSpot =
        a.type === 'spot' &&
        typeof a.item.id === 'string' &&
        favoriteSpotIds.has(a.item.id);
      const bIsFavoriteSpot =
        b.type === 'spot' &&
        typeof b.item.id === 'string' &&
        favoriteSpotIds.has(b.item.id);
      if (aIsFavoriteSpot && !bIsFavoriteSpot) return -1;
      if (!aIsFavoriteSpot && bIsFavoriteSpot) return 1;

      return 0;
    });
  }

  return spotList;
};
